import { ENGINEERS_REPORT, ERROR, TICKET_CETAGORY_BY_COMPANY_FAILURE, TICKET_CETAGORY_BY_COMPANY_REQUEST, TICKET_CETAGORY_BY_COMPANY_SUCCESS, TICKET_REPORT, TICKET_REPORT_FAILURE, TICKET_REPORT_REQUEST, TICKET_REPORT_SUCCESS } from '../actions/types';
const initialState: any = {
    dailyReports: [],
    sosReports: [],
    stores: [],
    customerReports: [],
    pmixReports: [],
    smixReports: [],
    channelmixReports: [],
    couponredemptionReports: [],
    profitReports: [],
    discountReports: [],
    ridersReports: [],
    storesReports: [],
    activity_logs: [],
    cancel_smryReports: [],
    cancel_detail_report: [],
    order_details_report: [],
    rider_details_report: [],
    ticket_report: [],
    ticket_cetagory_by_company: [],
    msg: "",
    currentPage: 0,
    pageCount: 0,
    numOfRows: 0,
    error: null
}

const reportReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case TICKET_REPORT: return {
            ...state,
            ticket_report: action.payload
        };

        case TICKET_REPORT_REQUEST:
        case TICKET_CETAGORY_BY_COMPANY_REQUEST:
            return { ...state, loading: true, error: null };

        case TICKET_REPORT_SUCCESS:
            return { ...state, ticket_report: action.payload, loading: false };

        case TICKET_CETAGORY_BY_COMPANY_SUCCESS:
            return { ...state, ticket_cetagory_by_company: action.payload, loading: false };

        case TICKET_REPORT_FAILURE:
        case TICKET_CETAGORY_BY_COMPANY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ENGINEERS_REPORT: return {
            ...state,
            storesReports: action.payload,
            currentPage: action.currentPage,
            pageCount: action.pageCount,
            numOfRows: action.numOfRows,
            msg: action.msg
        }
        case ERROR: return {
            ...state,
            msg: action.msg
        }

        default: return state;
    }
}
export default reportReducer;